import { UserTarget, UserTargetView } from '.';

export const ActionPointTargetTypes = [ 'AgendaItem', 'ActionPlanTopic' ] as const;
export type ActionPointTargetType = typeof ActionPointTargetTypes[number];

export type ActionPointRelation = 
    { name: Extract<ActionPointTargetType,'AgendaItem'>, agendaItemId:string } |
    { name: Extract<ActionPointTargetType,'ActionPlanTopic'>, actionPlanTopicId:string };

export type ActionPoint =
{
    id:string,
    activityId:string,
    relation:ActionPointRelation,
    description:string,
    assignedUser: UserTarget | null,
    deadline:Date | null,
    created:Date,
    done:boolean
};

export type ActionPointView =
{
    id:string,
    activityId:string,
    relation:ActionPointRelation,
    description:string,
    assignedUser: UserTargetView | null,
    deadline:Date | null,
    created:Date,
    done:boolean
}

export type ActionPointData =
{
    id:string,
    relation:ActionPointRelation,
    description:string,
    assignedUser: UserTargetView | null,
    deadline:Date | null,
    created:Date,
    done:boolean
}